<template>
  <div class="layout-container">
    <Sidebar :collapse="isCollapse" @toggle-collapse="toggleCollapse" />
    <div class="main-content" :class="{ 'collapsed': isCollapse }">
      <Topbar @toggle-sidebar="toggleCollapse" :collapse="isCollapse" />
      <div class="page-content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/Layout/Sidebar.vue'
import Topbar from '@/components/Layout/Topbar.vue'

export default {
  name: 'Layout',
  components: {
    Sidebar,
    Topbar
  },
  data() {
    return {
      isCollapse: false,        // 侧边栏折叠状态
      screenWidth: window.innerWidth,
      collapseWidth: 768        // 小于此宽度自动折叠
    }
  },
  created() {
    // 初始化时根据屏幕宽度设置折叠状态
    this.checkScreenWidth()
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    checkScreenWidth() {
      this.screenWidth = window.innerWidth
      if (this.screenWidth < this.collapseWidth) {
        this.isCollapse = true
      } else {
        // 如果用户手动展开过，不再自动强制折叠，但可以在初始化时设置
        // 这里只做初始化，避免覆盖用户手动操作
      }
    },
    handleResize() {
      this.screenWidth = window.innerWidth
      // 当宽度小于阈值时自动折叠
      if (this.screenWidth < this.collapseWidth && !this.isCollapse) {
        this.isCollapse = true
      } else if (this.screenWidth >= this.collapseWidth && this.isCollapse) {
        // 当宽度大于阈值时自动展开（可选，若希望自动展开）
        // 但为了用户体验，可以保留用户手动设置，不自动展开
        // 这里我们只做自动折叠，不自动展开
      }
    },
    toggleCollapse() {
      this.isCollapse = !this.isCollapse
    }
  }
}
</script>

<style scoped>
.layout-container {
  display: flex;
  height: 100vh;
  overflow: hidden;
}
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #f0f2f5;
  transition: margin-left 0.3s;
  min-width: 0; /* 防止flex溢出 */
}
.page-content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  overflow-x: hidden;
}
/* 当侧边栏折叠时，内容区域可以做一些调整（如padding） */
.main-content.collapsed .page-content {
  padding: 15px;
}
/* 小屏幕下减小内边距 */
@media screen and (max-width: 576px) {
  .page-content {
    padding: 10px !important;
  }
}
</style>
